<script>
import Tag from './Tag'

export default {

  props: {
    value: null,
    filterKey: null
  },

  computed: {
    tag() {
      return Tag.find(this.filterKey, this.value)
    }
  },

  methods: {
    setTag() {
      let newValue = prompt("Please enter a new tag:")
      if (!newValue) { return }

      Tag.set(this.filterKey, this.value, {
        "raw": this.value,
        "label": newValue
      })
    }
  }

}
</script>

<template>
  <div>
    <a @click="setTag">Change Tag</a>

    <span v-if="tag">
      {{ tag.label }}
      (Raw: {{ tag.raw }})
    </span>
    <span v-else>
      Raw: {{ value }}
    </span>
  </div>
</template>

<style>

</style>
